import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getBank, Icon, SimpleModal, InputWithIcon } from '@livable/saas-react-components';
import { Typography, MenuItem, Button, Checkbox, Divider, ListItemText, TextField } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useStore } from 'src/stores';
import useStyles from './styles';
const not = (a, b) => a.filter(value => !b.includes(value));
const intersection = (a, b) => a.filter(value => b.includes(value));
const union = (a, b) => [...a, ...not(b, a)];
const AssignPaymentMethodModal = observer(_ref => {
  let selectedPaymentMethod = _ref.selectedPaymentMethod,
    triggerRefresh = _ref.triggerRefresh,
    customTrigger = _ref.customTrigger;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    checked = _useState6[0],
    setChecked = _useState6[1];
  const _useState7 = useState(store.company.propertiesList),
    _useState8 = _slicedToArray(_useState7, 1),
    companyProperties = _useState8[0]; //setCompanyProperties

  const handleSearch = event => {
    var _event$target;
    const v = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;
    setSearchKey(v);
  };
  const getFilteredProperties = () => companyProperties.filter(p => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(p.propertyAddress).search(searchPhrase) > 0 : true;
  });
  const numberOfChecked = properties => intersection(checked, properties).length;
  const handleToggleAll = properties => () => {
    if (numberOfChecked(properties) === properties.length) {
      setChecked(not(checked, properties));
    } else {
      setChecked(union(checked, properties));
    }
  };
  const handleToggle = propertyId => () => {
    const currentIndex = checked.indexOf(propertyId);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(propertyId);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };
  const handleGenericModalClose = () => {
    setChecked([]);
    setSearchKey('');
  };
  const setPaymentMethod = async closeCallback => {
    setIsLoading(true);
    const setPropertyPayment = async propertyId => store.payment.setPropertyPaymentMethodAsync.run({
      propertyId: propertyId,
      paymentMethodId: selectedPaymentMethod.id
    });
    const respArr = [];
    for (const p of checked || []) {
      const contents = await setPropertyPayment(p);
      respArr.push(contents);
    }
    setIsLoading(false);
    if (respArr.some(r => r.isSuccessful)) {
      closeCallback();
      if (triggerRefresh) {
        triggerRefresh();
      }
    }
  };
  const modalTitle = "".concat(t('subscriptions.assign_payment_method'));
  const modalSubTitle = "".concat(getBank(selectedPaymentMethod.brand).title, " ****").concat(selectedPaymentMethod.last4);
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '278-assign-payment-method-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('buttons.change')));
  const ModalContent = _ref2 => {
    let handleModalClose = _ref2.handleModalClose,
      handler = _ref2.handler;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.form
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.formContent
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('subscriptions.select_property')), /*#__PURE__*/React.createElement("div", {
      className: classes.changePayment
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.searchField
    }, /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      fullWidth: true,
      placeholder: t('subscriptions.search_for_property'),
      value: searchKey,
      onChange: handleSearch
    }))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", {
      className: classes.filterMultiselectContainer
    }, /*#__PURE__*/React.createElement(MenuItem, {
      key: "select-all",
      variant: "multiple"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      onClick: handleToggleAll(getFilteredProperties().map(p => p.propertyId)),
      checked: numberOfChecked(getFilteredProperties().map(p => p.propertyId)) === getFilteredProperties().length && getFilteredProperties().length !== 0,
      disabled: getFilteredProperties().length === 0
    }), /*#__PURE__*/React.createElement(ListItemText, null, t('allocations.select_all_properties'))), getFilteredProperties().map(prop => /*#__PURE__*/React.createElement(MenuItem, {
      key: prop.propertyId,
      value: prop.propertyId,
      variant: "multiple",
      onClick: handleToggle(prop.propertyId)
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: checked.includes(prop.propertyId),
      tabIndex: -1,
      disableRipple: true
    }), /*#__PURE__*/React.createElement(ListItemText, {
      primary: prop.propertyAddress
    })))))), /*#__PURE__*/React.createElement("div", {
      className: classes.footerWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.rightButton
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      disabled: !checked.length || isLoading,
      onClick: () => {
        handler(handleModalClose);
      },
      'custom-attribute': '279-assign-payment-method-modal'
    }, t('buttons.save')))));
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: customTrigger !== undefined ? customTrigger : defaultTrigger || null,
    title: modalTitle,
    subTitle: modalSubTitle,
    handleClose: handleGenericModalClose,
    noFooter: true
  }, /*#__PURE__*/React.createElement(ModalContent, {
    handleModalClose: handleGenericModalClose,
    handler: setPaymentMethod
  }));
});
AssignPaymentMethodModal.propTypes = {
  trigger: PropTypes.node
};
export default AssignPaymentMethodModal;